<template>
  <ul class="language-menu" v-if="Object.keys(languages).length > 1">
    <li :class="getMenuClass('de-DE')" @click="setLanguage('de-DE')">
      <button text>DE</button>
    </li>
    <li
      :class="getMenuClass('en-US')"
      @click="setLanguage('en-US')"
      v-if="languages['en']"
    >
      <button text>EN</button>
    </li>
  </ul>
</template>

<script>
import { mapState, mapMutations } from 'vuex';

export default {
  data: () => ({
    activeClass: 'language-menu__active',
    inactiveClass: ''
  }),

  computed: {
    ...mapState('companyModule', {
      pageTitle: 'pageTitle',
      pageDescription: 'pageDescription',
      languages: 'languages',
      slug: 'slug'
    }),

    ...mapState({
      currentLanguage: 'currentLanguage'
    })
  },

  methods: {
    ...mapMutations({
      setCurrentLanguage: 'setCurrentLanguage'
    }),

    getMenuClass(langKey) {
      if (this.currentLanguage === langKey) {
        return this.activeClass;
      } else {
        return this.inactiveClass;
      }
    },

    setLanguage(langKey) {
      this.setCurrentLanguage(langKey);
      var shortLanguageKey = langKey.substring(0, 2);
      window.localStorage.setItem(`languageKey_${this.slug}`, shortLanguageKey);
      this.$i18n.locale = shortLanguageKey;
      document.title = this.localize(this.pageTitle);
      let meta = document.querySelector("meta[name='description']");
      if (meta) {
        meta.content = this.localize(this.pageDescription);
      }
    }
  }
};
</script>
